import React, { useState } from "react";
import { Tab, Tabs, Paper } from "@mui/material";

import CreateAccountForm from "./components/CreateAccountForm";
import { ContainerBg } from "../../useGeneralStyles";
import UsageHistory from "./components/UsageHistory";
import { TabPanel } from "../../components/ui";

const RithmicAccountCreationTool: React.FC = () => {
  const [activeTabIndex, setActiveTab] = useState(0);
  const onChangeActiveTab = (_: React.BaseSyntheticEvent, newValue: number) =>
    setActiveTab(newValue);

  return (
    <div>
      <Paper square>
        <Tabs value={activeTabIndex} onChange={onChangeActiveTab}>
          <Tab label="Create account" value={0} />
          <Tab label="Usage history" value={1} />
        </Tabs>
      </Paper>
      <ContainerBg
        sx={{
          minHeight: "calc(90vh - 30px)",
        }}
      >
        <TabPanel value={activeTabIndex} index={0}>
          <CreateAccountForm />
        </TabPanel>{" "}
        <TabPanel value={activeTabIndex} index={1}>
          <UsageHistory />
        </TabPanel>
      </ContainerBg>
    </div>
  );
};

export default RithmicAccountCreationTool;
